<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card flat class="rounded-lg primary--text mt-3 px-md-2">
          <v-row align="center">
            <v-col cols class="text-start ps-7">
              {{ $t("invoice.course") }}
            </v-col>

            <v-col cols="2" class="text-center">
              {{ $t("invoice.totalEmployees") }}
            </v-col>

            <v-col cols="2" class="text-center">
              {{ $t("invoice.totalQuantity") }}
            </v-col>

            <v-col cols="2" class="text-center">
              {{ $t("invoice.unitPrice") }}
            </v-col>

            <v-col cols="2" class="text-center">
              {{ $t("invoice.totalPrice") }}
            </v-col>

            <v-col cols="1" class="text-center"> </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="orderItems.length">
          <v-col
            cols="12"
            v-for="(data, index) in orderItems"
            :key="`InvoiceOrderItem-${index}`"
          >
            <InvoiceOrderItemsTableRow
              :key="`InvoiceOrderItemRow-${index}`"
              :data="data"
              @onClick="openTrainingDetailsDialog({ ...data, index })"
              @onDelete="deleteOrderItem(index)"
            />
          </v-col>
        </v-row>

        <v-row v-else justify="center" align="center">
          <v-col cols="auto" class="mt-16">
            <span class="textLight--text font-weight-light">
              {{ $t("invoice.noItemsSelected") }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--course selection dialog-->
    <InvoiceOrderItemDialog
      v-if="selectedTrainingDetails"
      :showDialogProp.sync="showTrainingDetailsDialog"
      :orderItemProp="selectedTrainingDetails"
      @onSubmit="updateOrderItem"
    />
  </div>
</template>

<script>
import InvoiceOrderItemsTableRow from "@/app/invoices-module/components/InvoiceOrderItemsTableRow";
import InvoiceOrderItemDialog from "@/app/invoices-module/components/InvoiceOrderItemDialog";

export default {
  name: "InvoiceOrderItemsTable",
  components: { InvoiceOrderItemsTableRow, InvoiceOrderItemDialog },
  props: {
    orderItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showTrainingDetailsDialog: false,
      selectedTrainingDetails: null,
    };
  },
  watch: {
    showTrainingDetailsDialog() {
      if (!this.showTrainingDetailsDialog) {
        this.selectedTrainingDetails = null;
      }
    },
  },
  methods: {
    openTrainingDetailsDialog(orderItem) {
      this.showTrainingDetailsDialog = true;
      this.selectedTrainingDetails = orderItem;
    },
    deleteOrderItem(index) {
      const clonedOrderItems = [...this.orderItems];
      clonedOrderItems.splice(index, 1);
      this.$emit("update:orderItems", clonedOrderItems);
    },
    updateOrderItem(orderItem) {
      if (orderItem.index != null) {
        const clonedOrderItems = [...this.orderItems];
        clonedOrderItems[orderItem.index] = orderItem;
        this.$emit("update:orderItems", clonedOrderItems);
      }

      this.showTrainingDetailsDialog = false;
      this.selectedTrainingDetails = null;
    },
  },
};
</script>
